// E15-T07 — mineração falha→teste-de-regressão: run que morreu num stopReason
// terminal vira CASO no eval set local do worktree (.apolo/evals/failures.jsonl)
// — o eval set cresce sozinho a partir da produção (doutrina Shankar/Husain:
// "evals que crescem da produção"). Repo as system of record: o caso fica no
// projeto, commitável. Best-effort: nunca derruba o run.

const EVAL_PATH = '.apolo/evals/failures.jsonl';
const MAX_CASES = 200; // poda: mais novo fica
const TERMINAL_FAILS = new Set([
  'tool_failure_spiral', 'tool_repeat_loop', 'stall_gave_up',
  'identical_output_loop', 'context_overflow', 'content_filtered',
]);

function bridgeApi() {
  const w = /** @type {any} */ (typeof window !== 'undefined' ? window : null);
  const api = w?.apolo || null;
  return api?.file?.read && api?.file?.write ? api : null;
}

async function readEvalFile(api, root) {
  try {
    const r = await api.file.read({ root, filePath: EVAL_PATH });
    return r && r.ok !== false && typeof r.content === 'string' ? r.content : '';
  } catch { return ''; }
}

/** Anexa a linha nova e poda pro cap (mais novo fica). PURO. */
function appendCase(existing, line) {
  const lines = existing.split('\n').filter(Boolean);
  lines.push(line);
  return lines.slice(-MAX_CASES).join('\n') + '\n';
}

/** @param {{root?: string, taskText?: string, result?: any}} [run] */
export async function mineFailureToEvalSet({ root, taskText, result } = {}) {
  try {
    if (!root || !TERMINAL_FAILS.has(result?.stopReason)) return false;
    const api = bridgeApi();
    if (!api) return false;
    const prompt = String(taskText || '').replace(/\s+/g, ' ').trim().slice(0, 300);
    if (!prompt) return false;
    const existing = await readEvalFile(api, root);
    // Dedupe: o MESMO prompt+stopReason já minerado não entra de novo.
    const key = `"stopReason":${JSON.stringify(result.stopReason)},"prompt":${JSON.stringify(prompt)}`;
    if (existing.includes(key)) return false;
    const line = `{"at":${JSON.stringify(new Date().toISOString().slice(0, 16))},${key},"iterations":${Number(result.iterations) || 0}}`;
    const res = await api.file.write({ root, filePath: EVAL_PATH, content: appendCase(existing, line) });
    // Auditoria 07-06 (R3): o worktree da sessão é EFÊMERO — o caso minerado
    // morria com ele. Espelho best-effort em ~/.apolo/evals/ (sobrevive; o
    // eval-runner e o daily-improve leem de lá). Heredoc quoted = sem expansão.
    try {
      await api.shell?.exec?.({
        command: `mkdir -p "$HOME/.apolo/evals" && cat >> "$HOME/.apolo/evals/failures.jsonl" <<'APOLO_EVAL_EOF'\n${line}\nAPOLO_EVAL_EOF`,
        cwd: root, runId: `eval-mirror-${Date.now()}`,
      });
    } catch { /* espelho é best-effort */ }
    return !(res && res.ok === false);
  } catch {
    return false;
  }
}
